// extracted by mini-css-extract-plugin
export default {"title":"style_title__gDfY2","item":"style_item__X46Yk","status":"style_status__5eT75"};